export default "__VITE_ASSET__Bp8SMS9e__"